export interface SchulferienZeitraum {
  start: string;
  end: string;
  name: string;
}

export const buildSchulferienEvents = (ferienZeitraeume: SchulferienZeitraum[]) => {
  const ferienEvents: Array<{
    id: string;
    startTime: string;
    endTime: string;
    title: string;
    bgColor: string;
    textColor: string;
    ganzTaegig: number;
    wiederholen: string;
    isSchulferien: boolean;
  }> = [];

  ferienZeitraeume.forEach((ferien, index) => {
    const startDate = new Date(`${ferien.start}T00:00:00`);
    const endDate = new Date(`${ferien.end}T00:00:00`);

    let currentDate = new Date(startDate);
    let dayIndex = 0;

    while (currentDate <= endDate) {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const dateStr = `${year}-${month}-${day}`;

      ferienEvents.push({
        id: `schulferien-${index}-${dayIndex}`,
        startTime: `${dateStr}T00:00`,
        endTime: `${dateStr}T23:59`,
        title: ferien.name,
        bgColor: "#3498db",
        textColor: "white",
        ganzTaegig: 1,
        wiederholen: "nie",
        isSchulferien: true,
      });

      currentDate.setDate(currentDate.getDate() + 1);
      dayIndex++;
    }
  });

  return ferienEvents;
};
